import { render } from "./VaultsList.vue?vue&type=template&id=6f586939&scoped=true"
import script from "./VaultsList.vue?vue&type=script&lang=ts"
export * from "./VaultsList.vue?vue&type=script&lang=ts"

import "./VaultsList.vue?vue&type=style&index=0&id=6f586939&scoped=true&lang=css"
import "./VaultsList.vue?vue&type=style&index=1&id=6f586939&lang=css"
script.render = render
script.__scopeId = "data-v-6f586939"

export default script